import _classCallCheck from "C:\\DC_L\\project\\tone-the-ear\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\DC_L\\project\\tone-the-ear\\node_modules\\@babel\\runtime/helpers/esm/createClass";
var channelNames = {
  "1": "modulationWheel",
  "2": "breath",
  "4": "footController",
  "5": "portamentoTime",
  "7": "volume",
  "8": "balance",
  "10": "pan",
  "64": "sustain",
  "65": "portamentoTime",
  "66": "sostenuto",
  "67": "softPedal",
  "68": "legatoFootswitch",
  "84": "portamentoContro"
};

var Control =
/*#__PURE__*/
function () {
  function Control(number, time, value) {
    _classCallCheck(this, Control);

    this.number = number;
    this.time = time;
    this.value = value;
  }
  /**
   * The common name of the control change event
   * @type {String}
   * @readOnly
   */


  _createClass(Control, [{
    key: "name",
    get: function get() {
      if (channelNames.hasOwnProperty(this.number)) {
        return channelNames[this.number];
      }
    }
  }]);

  return Control;
}();

export { Control };